import { useEffect, useRef, useState } from "react";

import { MeasureCanvas } from "./MeasureCanvas";
import { buildFontTemplate, truncateText } from "./TruncatedTextUtils";

// This hook is used to truncate text to fit within a given width.
// truncation can be recalculated if the text, width, maxWidth, or size changes.
// It needs the size and weight of the font to be used, the text, and max allowed width to truncate.
// It assumes the font is the same as Text's font

// This hook loses performance when a string > 10000 characters is passed in due to the use of a canvas measurement.
export const useTruncatedText = (
	text: string,
	maxWidth: number,
	size: string,
	weight: string,
	truncationSuffix = "..."
) => {
	const [truncatedText, setTruncatedText] = useState("");
	const didTruncateText = useRef<null | boolean>(null);
	const fullTextWidth = useRef(0);

	useEffect(() => {
		const getTruncationIfNeeded = async () => {
			const fontString = buildFontTemplate(size, weight);

			const measureCanvas = new MeasureCanvas();
			const fullWidth = measureCanvas.getTextWidth(text, fontString);
			let truncatedText = text;

			if (fullWidth > maxWidth) {
				truncatedText = truncateText(text, fontString, maxWidth, truncationSuffix, measureCanvas);
				didTruncateText.current = true;
			} else {
				didTruncateText.current = false;
			}

			fullTextWidth.current = fullWidth;
			setTruncatedText(truncatedText);
		};

		getTruncationIfNeeded();
	}, [text, maxWidth, size, weight]);

	return {
		truncatedText,
		fullTextWidth: fullTextWidth.current,
		didTruncateText: didTruncateText.current,
	};
};
